<template>
  <div class="container mx-auto mt-8">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-2">
      <div
        class="container hover:bg-gray-100 p-2 rounded-md mx-auto border border-gray-200 text-sm"
        v-for="{
          id,
          store_name,
          store_address,
          owner_name,
          owner_email,
          phone,
          city,
          billing_address,
          country,
        } in distributors"
        :key="id"
      >
        <!-- Update / Delete buttons -->
        <div class="block ml-auto w-max">
          <router-link :to="`/edit/${id}`">
            <button
              class="text-xs hover:text-white text-green-400 hover:bg-green-400 py-1 px-2 border border-green-400 rounded-md mx-4 inline-block ml-auto"
            >
              Upraviť
            </button>
          </router-link>
          <button
            class="text-xs  hover:border hover:border-red-400 hover:border-red-500 hover:bg-red-500 hover:text-white rounded-md py-1 px-2 mx-1 inline-block ml-auto"
            @click="deleteDistributor(id)"
          >
            Odstrániť
          </button>
        </div>
        <h2 class="font-semibold text-md text-left">{{ store_name }}</h2>
        <p v-if="store_address" class="text-left text-xs font-extralight">Adresa predajne</p>
        <p class="text-left text-md">{{ store_address }}</p>
        <p v-if="owner_name" class="text-left text-xs font-extralight">Meno / vlastník</p>
        <p class="text-left text-md">{{ owner_name }}</p>
        <p v-if="owner_email" class="text-left text-xs font-extralight">Email</p>
        <p class="text-left text-md">{{ owner_email }}</p>
        <p v-if="phone" class="text-left text-xs font-extralight">Telefón</p>
        <p class="text-left text-md">{{ phone }}</p>
        <p v-if="city" class="text-left text-xs font-extralight">Mesto</p>
        <p class="text-left text-md">{{ city }}</p>
        <p v-if="billing_address" class="text-left text-xs font-extralight">Fakturačná adresa</p>
        <p class="text-left text-md">{{ billing_address }}</p>
        <p v-if="country" class="text-left text-xs font-extralight">Krajina</p>
        <p class="text-left text-md">{{ country }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { useLoadDistributors, deleteDistributor } from "../firebase";

export default {
  setup() {
    const distributors = useLoadDistributors();

    return { distributors, deleteDistributor };
  },
};
</script>
